import React, { useState, useEffect } from "react";
import UserForm from "./UserForm";
import { useParams } from "react-router-dom";
import { getUserData } from "../../services/userServices";
import { editUserSchema } from "../../validations/UserValidation";

export default function UserEdit() {
  const [userData, setUserData] = useState([]);
  const { id } = useParams();

  const handleGetUserData = async (id) => {
    
    try {
      const data = await getUserData(id);
      
      setUserData(data.user);
    } catch (err) {
      if (!err?.response) {
        
      }
    }
  };

  useEffect(() => {
    
    handleGetUserData(id);
  }, []);

  const initialValues = {
    name: userData.name || "",
    lastName: userData.last_name || "",
    email: userData.email || "",
    phone: userData.phone || "",
    username: userData.username || "",
    role: userData.role || "",
    password: "",
    confirmationPassword: "",
    currentPassword: "",
  };
  return (
    <div>
      <UserForm
        title="Editar usuario"
        initialValues={initialValues}
        validationSchema={editUserSchema}
        newUser={false}
        id={id}
      />
    </div>
  );
}
